import { useEffect } from "react";

import { useSelector } from "react-redux";
import { Link, useParams, useRouteMatch } from 'react-router-dom'

import SaveStatus from '../../UIComponents/SaveStatus'
import LinkList from "../../UIComponents/LinkList";

import mapStateToProps from './mapStateToProps'

const DocumentList = ()=>{
    const { 
        getPlanScheduleStatuses=()=>{},
        getOrderWorkStatuses=()=>{},
        rights={},
        
    } = useSelector(mapStateToProps);
    useEffect(()=>{
      getPlanScheduleStatuses({docId: "planSchedule"})
      getOrderWorkStatuses({docId: "orderWork"})
    },[])
    const rightCheck=(mainPart)=>{
        return (
            rights?.[`${mainPart}-view`] ||
            rights?.[`${mainPart}-create`] ||
            rights?.[`${mainPart}-edit`] ||
            rights?.[`${mainPart}-delete`] ||
            rights?.[`${mainPart}-approve`]
        )
    }
    const listFull = [
      {id:'schedule', name:'План-график', rightsName:'plan'},
      {id:'work-order', name:'Заказ-наряд', rightsName:'order'},
  ]
    const list = listFull.filter(({rightsName})=>rightCheck(rightsName))
    const { docname } = useParams();
    // const match = useRouteMatch();

    // useEffect(()=>{
    //     getDirectoryList()
    // },[])
    // const list = [
    //     {id:'schedule', name:'План-график', rightsName:'plan'},
    //     {id:'work-order', name:'Заказ-наряд', rightsName:'order'},
    // ]
    return (
        <>
            {/* <SaveStatus title="Загрузка списка спрвочников" dataObj={directoryList} successShowTime={100}/> */}
            {/* {list.length?list.map(({id, name})=>(<Link to={`/directory/${id}`} key={id}>{name}</Link> )):null} */}
            <LinkList linkArr={list.map(({id, name})=>({link:`/document/${id}`,selected:(id===docname), label:name}))} />
        </>
    )
}

export default DocumentList;